let i = 1;

/**
 * Generates an incrementing integer. Useful for generating unique DOM ids.
 * @returns The next integer in the sequence.
 */
export function next(): number {
    return i++;
}
